import { Analytics } from "cookiesConsent/domain/analytics"
import { Customer, Visitor } from "cookiesConsent/domain/visitor"

export class DeduplicatedGuestAnalytics implements Analytics {
  private readonly identifiedGuestEmails: Set<string> = new Set()

  private readonly analytics: Analytics

  constructor(analytics: Analytics) {
    this.analytics = analytics
  }

  identify = (visitor: Visitor): void => {
    if (visitor instanceof Customer) {
      this.analytics.identify(visitor)
    } else if (this.identifiedGuestEmails.has(visitor.email.value)) {
      this.withhold()
    } else {
      this.identifiedGuestEmails.add(visitor.email.value)
      this.analytics.identify(visitor)
    }
  }

  remembersCustomer = (): boolean => this.analytics.remembersCustomer()

  forget = (): void => {
    this.identifiedGuestEmails.clear()
    this.analytics.forget()
  }

  private withhold = (): void => {}
}
